const { isEmpty, omit, } = require('lodash');

const { idWithTenant } = require('../util');
const { shippingOptions, } = require('./shippingRequest');

const conditionFieldTypes = {
  product: { label: '商品' },
  postalCode: { label: '配送先郵便番号' },
};

const conditionOperators = {
  product: {
    contains: { label: '含む' },
  },
  postalCode: {
    startsWith: { label: '前方一致' },
  },
};

const actionTypes = {
  setStatusPending: { label: 'ステータスを保留中にする' },
  skipShippingRequest: { label: '出荷依頼を作成しない' },
  addShippingOptions: { label: 'オプションを追加する' },
};

// 印刷同封はPDF、代引きは金額の入力が別途必要なため、マクロでは付けられない
const macroShippingOptions = omit(shippingOptions, ['print', 'codAll']);

const fields = () => {
  return {
    name: {
      label: 'マクロ名',
      type: 'string',
      validations: {
        required: _ => !isEmpty(_),
      },
    },
    isEnabled: {
      label: '有効',
      type: 'boolean',
      initialValue: true,
    },
  };
};

const conditionFields = ({ products = [], condition = {} } = {}) => {
  const fieldType = condition.fieldType || 'product';
  return {
    fieldType: {
      label: '対象',
      type: 'select',
      options: Object.entries(conditionFieldTypes).map(([k, v]) => ({ value: k, label: v.label })),
      initialValue: 'product',
      validations: {
        required: _ => !isEmpty(_),
      },
    },
    operator: {
      label: '条件',
      type: 'select',
      options: Object.entries(conditionOperators[fieldType] || {}).map(([k, v]) => ({ value: k, label: v.label })),
      initialValue: 'contains',
      validations: {
        required: _ => !isEmpty(_),
      },
    },
    productId: {
      label: '商品',
      type: 'select',
      options: products.map(_ => ({ label: `${idWithTenant(_.ref)} [${_.sku}] ${_.name}`, value: _.id })),
      hidden: _ => _.fieldType !== 'product',
      validations: {
        required: (v, state) => state.fieldType !== 'product' || !isEmpty(v),
      },
    },
    postalCodes: {
      label: '郵便番号',
      type: 'text',
      hint: '1行に1つ（例: 907）',
      hidden: _ => _.fieldType !== 'postalCode',
      validations: {
        required: (v, state) => state.fieldType !== 'postalCode' || !isEmpty(v),
      },
    },
  };
};

const actionFields = () => {
  return {
    type: {
      label: 'アクション',
      type: 'select',
      options: Object.entries(actionTypes).map(([k, v]) => ({ value: k, label: v.label })),
      initialValue: 'setStatusPending',
      validations: {
        required: _ => !isEmpty(_),
      },
    },
    shippingOptionValues: {
      label: 'オプション',
      type: 'multiSelect',
      options: Object.entries(macroShippingOptions).map(([k, v]) => ({ value: k, label: v.label })),
      initialValue: [],
      hidden: _ => _.type !== 'addShippingOptions',
      validations: {
        required: (v, state) => state.type !== 'addShippingOptions' || !isEmpty(v),
      },
    },
  };
};

module.exports = {
  fields,
  conditionFields,
  actionFields,
  conditionFieldTypes,
  conditionOperators,
  actionTypes,
  macroShippingOptions,
};
